import BaseItemSerializer from './base-item';

export default class UncertaintySerializer extends BaseItemSerializer {}
